<template>
    <v-row justify="center">
      <!-- หน้าจอธรรมดา -->
      <v-dialog
        v-if="resolutionScreen >= 500"
        v-model="shower"
        scrollable
        persistent
        max-width="500px"
      >
        <v-card>
          <v-card-title
            >{{ $t("admin.updategroup") }}<v-spacer></v-spacer>
            <v-icon :color="color.theme" dense dark size="35">mdi-account-group</v-icon>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <br />
            <v-text-field
              :color="color.theme"
              prepend-icon="mdi-file-settings-outline"
              dense
              outlined
              :label="$t('changeName.addname')"
              v-model="groupname"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red"
              outlined
              @click="$emit('close'), (groupname = '')"
              :disabled="createprogress"
              >{{ $t("checkpassword.cancel") }}</v-btn
            >
            <v-btn
              :color="color.theme"
              :dark="color.darkTheme"
              @click="fn_updategroup()"
              :loading="createprogress"
            >
              {{ $t("changeName.submit") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- หน้าจอมือถือ -->
      <v-dialog
        persistent
        :max-width="maxWidthOnMobile"
        content-class="rounded-lg"
        v-else
        v-model="shower"
      >
        <v-card>
          <v-card-text class="pa-5">
            <v-layout class="pt-2 pb-4">
              <v-flex d-flex justify-center class="ml-8">
                <span :style="headerPage">{{ $t("admin.updategroup") }}</span>
              </v-flex>
              <v-flex xs1 d-flex justify-end>
                <v-icon
                  :color="$vuetify.theme.dark ? 'white' : color.theme"
                  @click="$emit('close')"
                  >mdi-account-group</v-icon
                >
              </v-flex>
            </v-layout>
            <span :style="titleText">{{ $t("changeName.addname") }}</span>
            <v-text-field
              class="mt-1 textFieldClass"
              :color="color.theme"
              outlined
              dense
              multiple
              v-model="groupname"
              :disabled="createprogress"
            ></v-text-field>
          </v-card-text>
          <div class="text-center pb-4 mt-n2">
            <v-btn
              :style="btnAction"
              class="mr-6"
              height="40px"
              width="40%"
              color="red"
              outlined
              :disabled="createprogress"
               @click="$emit('close'), (groupname = '')"
              >{{ $t("checkpassword.cancel") }}</v-btn
            >
            <v-btn
              height="40px"
              width="40%"
              class="elevation-0"
              :style="btnAction"
              :color="color.theme"
              :dark="color.darkTheme"
              @click="fn_updategroup()"
              :loading="createprogress"
              >{{ $t("checkpassword.ok") }}</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
    </v-row>
  </template>
  <script>
  import { mapState, mapGetters } from "vuex";
  import Swal from "sweetalert2/dist/sweetalert2.js";
  import "sweetalert2/src/sweetalert2.scss";
  import { validationMixin } from "vuelidate";
  import { required, maxLength, email, helpers } from "vuelidate/lib/validators";
  import gbfGenerate from "@/globalFunctions/generateAuthorize";
  import checkCharacter from "@/globalFunctions/checkCharacter";
  
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
  });
  
  const SpecialCharacterForFoldernameValidator = helpers.regex(
    "SpecialCharacterForFoldername",
    checkCharacter.checkSpecialCharacterForFoldername()
  );
  export default {
    mixins: [validationMixin],
    validations: {
      filename: { required, SpecialCharacterForFoldernameValidator },
    },
    props: ["show","dataupdategroup"],
    data: function() {
      return {
        groupname: "",
        createprogress: false,
      };
    },
    computed: {
      ...mapState(["username", "authorize", "account_active", "color"]),
      ...mapState({ processloader: "loading" }),
      ...mapGetters([
        "dataUsername",
        "dataAuthorize",
        "dataAccountActive",
        "dataAccesstoken",
        "dataBusinessProfile",
        "dataCitizenProfile",
        "dataDepartmentAccessId",
        "dataAccountId",
      ]),
      shower: {
        get() {
          if (this.show === true) {
            this.groupname = this.dataupdategroup.group_name
          }
          return this.show;
        },
        set(value) {
          if (!value) {
          }
        },
      },
  
      resolutionScreen() {
        switch (this.$vuetify.breakpoint.name) {
          case "xs":
            return 220;
          case "sm":
            return 400;
          case "md":
            return 500;
          case "lg":
            return 600;
          case "xl":
            return 800;
        }
      },
      // style อักษรใน dialog ของ mobile
      titleText() {
        return "color:black; font-size: 14px; line-height: 28px;";
      },
      // style อักษร header ของ mobile
      headerPage() {
        return (
          "color:" +
          this.color.theme +
          ";" +
          "font-size: 16px; font-weight: 600; font-weight: bold; letter-spacing: 0px;"
        );
      },
      // style ปุ่ม ของ mobile
      btnAction() {
        return "font-size: 16px; font-weight: lighter;";
      },
      // ความกว้างของ dialog ของ ipad และ mobile
      maxWidthOnMobile() {
        if (this.resolutionScreen >= 400) {
          return 600;
        } else {
          return 346;
        }
      },
    },
    methods: {
      async fn_updategroup() {
        this.createprogress = true;
        let payload = {
          business_id: this.dataupdategroup.business_id,
          account_id: this.dataAccountId,
          new_group_name: this.groupname,
          group_id: this.dataupdategroup.id

        };
        console.log("payload", payload);
        let auth = await gbfGenerate.generateToken();
        this.axios
          // .post(
          //   process.env.VUE_APP_SERVICE_DOWNLOAD_API + "/api/admin/update_group",
          //   payload,
          //   { headers: { Authorization: auth.code } }
          // )
          .post(" https://f9300388b7d4.ngrok-free.app/api/admin/update_group",
            payload,
            { headers: { Authorization: auth.code } }
          )
          .then((response) => {
            console.log(response);
            if (response.data.status === "OK") {
              console.log("response111",response);
              
              let msgres = response.data.message
              Toast.fire({
                icon: "success",
                title: msgres,
              });
              this.$emit("reload");
            //   this.groupname = '';
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.errorMessage,
              });
            }
            this.createprogress = false;
          })
          .catch((error) => {
            console.log(error);
            Toast.fire({
              icon: "error",
              title: this.$t("changeName.noChange"),
            });
            this.createprogress = false;
          });
      },
    },
  };
  </script>
  <style>
  .v-input.textFieldClass input {
    font-size: 14px;
  }
  </style>
  